import "antd/lib/form/style";
import _Form from "antd/lib/form";
import "antd/lib/card/style";
import _Card from "antd/lib/card";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/date-picker/style";
import _DatePicker from "antd/lib/date-picker";
import "antd/lib/radio/style";
import _Radio from "antd/lib/radio";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@运维-设备信息*/
import React from 'react';
import { connect } from 'dva';
import BossLineChart from "../../../Common/Charts/Line/BossLineChart";
import moment from 'moment';
import noWan from '../../../../assets/img/noWan.png';
import { withRouter } from 'react-router-dom';
import { injectIntl } from "react-intl";
var Option = _Select.Option;
var RadioGrp = _Radio.Group;
var RangePicker = _DatePicker.RangePicker;
var TunnelInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(TunnelInfo, _React$Component);
  function TunnelInfo(props) {
    var _this;
    _classCallCheck(this, TunnelInfo);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TunnelInfo).call(this, props)); //获取隧道信息的各类数据
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_tunnel_data", function () {
      _this.props.dispatch({
        type: "mi0102Info/get_tunnel_data",
        payload: {
          tunnel_id: _this.props.link_id,
          companyid: _this.props.company_id,
          start_tm: _this.state.start_tm,
          end_tm: _this.state.end_tm,
          tid: _this.props.link_id,
          sn: _this.props.sn,
          from: "link"
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTimeInterval", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      var start_tm = "";
      var end_tm = moment().format("YYYY-MM-DD HH:mm:ss");
      switch (value) {
        case "0":
          start_tm = moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "1":
          start_tm = moment().subtract(6, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "2":
          start_tm = moment().subtract(24, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "3":
          start_tm = moment().subtract(7, 'days').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "10":
          start_tm = moment().subtract(1, 'month').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "11":
          start_tm = moment().subtract(1, 'year').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "setFree":
          break;
        default:
          start_tm = moment().subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss");
          break;
      }
      if (value === 'setFree') {
        _this.setState({
          intervalType: value,
          setFree: true
        }, function () {
          vm.get_tunnel_data();
        });
      } else {
        _this.setState({
          start_tm: start_tm,
          end_tm: end_tm,
          intervalType: value,
          setFree: false
        }, function () {
          vm.get_tunnel_data();
        });
      }
    }); //切换图表刷新间隔时间
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectRefreshInterval", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      var timeInterval;
      clearInterval(_this.state.offId);
      _this.props.mi0102Info.refreshType = value;
      switch (value) {
        case "0":
          return;
        case "1":
          timeInterval = 15 * 1000;
          break;
        case "2":
          timeInterval = 30 * 1000;
          break;
        case "3":
          timeInterval = 60 * 1000;
          break;
        default:
          return;
      }
      var offId = setInterval(function () {
        vm.selectTimeInterval(vm.state.intervalType);
      }, timeInterval);
      _this.setState({
        offId: offId
      });
      sessionStorage.setItem("tunnelOffId", offId);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disabledDate", function (current) {
      return current.diff(_this.state.start_tm, 'days') < -5 || current.diff(_this.state.start_tm, 'days') > 6;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRangeChange", function (moment) {
      if (moment.length === 1) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss")
        });
      } else if (moment.length === 2) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss"),
          end_tm: moment[1].format("YYYY-MM-DD HH:mm:ss")
        }, function () {
          _this.get_tunnel_data();
        });
      }
    });
    _this.state = {
      end_tm: moment().format("YYYY-MM-DD HH:mm:ss"),
      start_tm: moment().subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss")
    };
    return _this;
  }
  _createClass(TunnelInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_tunnel_data();
      this.props.dispatch({
        type: "mi0102Info/set_tunnel_info",
        payload: {
          id: this.props.link_id
        }
      });
      this.props.dispatch({
        type: "mi0102Info/set_tunnel_bandwidth",
        payload: {
          bandwidth: this.props.bandwidth
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var inEnglish = window.appLocale.locale === "en-US";
      var chartPropsI = {
        id: "tunnelSpeed",
        containerHeight: 400,
        containerWidth: "110%",
        option: {
          xAxis: {
            type: 'time',
            boundaryGap: true,
            name: "time",
            min: this.state.start_tm,
            max: this.state.end_tm
          },
          yAxis: {
            type: 'value',
            name: "Rate (Mbps)"
          },
          series: this.props.mi0102Info.tunnelInfoSeries.speed
        }
      };
      var chartPropsII = {
        id: "RTT",
        containerHeight: 400,
        containerWidth: "110%",
        option: {
          xAxis: {
            type: 'time',
            boundaryGap: false,
            name: "time",
            min: this.state.start_tm,
            max: this.state.end_tm
          },
          yAxis: [{
            type: 'value',
            name: "Network latency (ms)",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }, sessionStorage.getItem("role") === 'company' || sessionStorage.getItem('role') === 'companystaff' ? {
            type: 'value',
            name: "",
            boundaryGap: false,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          } : {
            type: 'value',
            name: "Get(ms)",
            boundaryGap: false,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }],
          series: this.props.mi0102Info.tunnelInfoSeries.rttGet
        }
      };
      var chartPropsIII = {
        id: "sessionCount",
        containerHeight: 400,
        containerWidth: "110%",
        option: {
          xAxis: {
            type: 'time',
            boundaryGap: false,
            min: this.state.start_tm,
            max: this.state.end_tm,
            axisTick: {
              show: false
            }
          },
          yAxis: {
            type: 'value',
            name: "Number of sessions",
            minInterval: 1
          },
          series: this.props.mi0102Info.tunnelInfoSeries.session
        }
      };
      var mi0102Info = this.props.mi0102Info;
      var option = [/*#__PURE__*/React.createElement(Option, {
        value: "0",
        key: "0"
      }, "Last 30 minutes"), /*#__PURE__*/React.createElement(Option, {
        value: "1",
        key: "1"
      }, "Last 6 hours"), /*#__PURE__*/React.createElement(Option, {
        value: "2",
        key: "2"
      }, "Last Day"), /*#__PURE__*/React.createElement(Option, {
        value: "3",
        key: "3"
      }, "Last week"), /*#__PURE__*/React.createElement(Option, {
        value: "10",
        key: "10"
      }, "Last month"), /*#__PURE__*/React.createElement(Option, {
        value: "11",
        key: "11"
      }, "Last year"), /*#__PURE__*/React.createElement(Option, {
        value: "setFree",
        key: "setFree"
      }, "User defined")]; //前后30分钟、前后1小时、前后6小时、前后24小时、前后2天和前后1周
      var tunnelId = this.props.link_id;
      var dateFormat = 'YYYY-MM-DD HH:mm:ss';
      return /*#__PURE__*/React.createElement(_Card, {
        className: "card"
      }, mi0102Info.tunnelList.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioGrp, {
        style: {
          marginBottom: 16
        },
        value: tunnelId,
        onChange: this.handleSelectTunnelType
      }, /*#__PURE__*/React.createElement(_Radio, {
        key: tunnelId,
        value: tunnelId
      }, "tunnel_" + tunnelId)), /*#__PURE__*/React.createElement("header", {
        style: {
          marginBottom: 16
        }
      }, /*#__PURE__*/React.createElement(_Select, {
        style: {
          width: inEnglish ? 250 : 150,
          marginRight: 8
        },
        placeholder: "Please select a time interval",
        onChange: this.selectTimeInterval,
        defaultValue: "0"
      }, option), /*#__PURE__*/React.createElement(RangePicker, {
        disabled: !this.state.setFree,
        style: {
          width: 350,
          marginRight: 8
        },
        showTime: true,
        value: [moment(this.state.start_tm, dateFormat), moment(this.state.end_tm, dateFormat)],
        onCalendarChange: this.handleRangeChange
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 16
        }
      }, /*#__PURE__*/React.createElement(BossLineChart, Object.assign({}, chartPropsI, {
        ifNotMerge: true
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 16
        }
      }, /*#__PURE__*/React.createElement(BossLineChart, Object.assign({}, chartPropsII, {
        ifNotMerge: true
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 16
        }
      }, /*#__PURE__*/React.createElement(BossLineChart, Object.assign({}, chartPropsIII, {
        ifNotMerge: true
      })))) : /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: noWan,
        alt: "",
        style: {
          marginTop: 60
        }
      })));
    }
  }]);
  return TunnelInfo;
}(React.Component);
function mapDispatchToProps(_ref) {
  var mi0102Info = _ref.mi0102Info;
  return {
    mi0102Info: mi0102Info
  };
}
export default connect(mapDispatchToProps)(_Form.create()(withRouter(injectIntl(TunnelInfo))));